import { get } from '@client/lib/request';

export const fetchCategorySubline = (gender: string) =>
    get('/api/mylounge-articles/commodity-groups', { gender });
